module.exports = __webpack_public_path__ + "d3dccda3be955670441a842256e80465.png";